import { configureStore } from "@reduxjs/toolkit";
import autoMergeLevel2 from "redux-persist/lib/stateReconciler/autoMergeLevel2";
import { combineReducers } from "redux";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import BMCProfileSlice from "./slices/bMCProfileSlice";
import maintenanceRequestsSlice, {
  getMaintenanceRequestsListenerMiddleware,
} from "./slices/maintenanceRequestsSlice";
import breadCrumbReducer from "./slices/breadCrumbSlice";
import ateCasesSlice, {
  getATECasesListenerMiddleware,
} from "./slices/ateCasesSlice";
import lookupSlice from "./slices/lookupSlice";
import sharedSlice from "./slices/sharedSlice";
import civilDefenseSlice from "./slices/civilDefenseSlice";
import assignBuildingSlice, {
  getAssignedBuildingsListenerMiddleware,
} from "./slices/assignBuildingSlice";
import axiosAuth from "../middleWares/axiosAuth";
import preventiveAppointmentsSlice, {
  getAppointmentsListenerMiddleware,
} from "./slices/preventiveAppointmentSlice";
import invoiceSlice, {
  getInvoicesListenerMiddleware,
  getConsolidatedInvoicesListenerMiddleware,
} from "./slices/invoiceSlice";
import { DELAY_TIME } from "src/resources/constant";
import dashboardSlice from "./slices/dashboardSlice";
import bmcWithRatingSlice, {
  getBMCWithRatingListenerMiddleware,
} from "./slices/bmcWithRatingSlice";
const persistConfig = {
  key: "root",
  timeout: DELAY_TIME,
  storage,
  whitelist: ["assignBuilding", "lookup"],
  stateReconciler: autoMergeLevel2,
};

const rootReducer = combineReducers({
  bMCProfile: BMCProfileSlice,
  maintenanceRequests: maintenanceRequestsSlice,
  breadCrumb: breadCrumbReducer,
  preventiveAppointments: preventiveAppointmentsSlice,
  lookup: lookupSlice,
  assignBuilding: assignBuildingSlice,
  ateCases: ateCasesSlice,
  shared: sharedSlice,
  civilDefense:civilDefenseSlice,
  invoices: invoiceSlice,
  dashboard: dashboardSlice,
  bmcWithRating: bmcWithRatingSlice,
});

const persistedReducer = persistReducer(persistConfig, rootReducer as any);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) => {
    return getDefaultMiddleware({ serializableCheck: false }).prepend(
      axiosAuth,
      getMaintenanceRequestsListenerMiddleware.middleware,
      getATECasesListenerMiddleware.middleware,
      getAppointmentsListenerMiddleware.middleware,
      getAssignedBuildingsListenerMiddleware.middleware,
      getInvoicesListenerMiddleware.middleware,
      getConsolidatedInvoicesListenerMiddleware.middleware,
      getBMCWithRatingListenerMiddleware.middleware
    );
  },
  devTools: true,
});
